export const FETCH_JIRA_ISSUE_DETAILS_REQUEST = "FETCH_JIRA_ISSUE_DETAILS_REQUEST";
export const FETCH_JIRA_ISSUE_DETAILS_SUCCESS = "FETCH_JIRA_ISSUE_DETAILS_SUCCESS";
export const FETCH_JIRA_ISSUE_DETAILS_FAILURE = "FETCH_JIRA_ISSUE_DETAILS_FAILURE";
